import { useEffect } from "react";

import * as GitpodCookie from "@/gitpod-cookie";
import { useGetAccount } from "@/queries/account-queries";

export function useGitpodCookie() {
    const { data: account } = useGetAccount();
    useEffect(() => {
        if (account && !GitpodCookie.isCookiePresent()) {
            GitpodCookie.installCookie(window.location.href);
        }
    }, [account]);
}
